import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/top-features-icon1.svg")